module.exports = __webpack_public_path__ + "static/media/template.b4250148.svg";